import styled from '@emotion/styled';

const InputContainer = styled('div')`
  position: relative;
  box-sizing: border-box;
  width: ${({maxWidth}) => maxWidth};
  
  > input,
  textarea.textarea-field {
    width: 100%;
    height: 40px;
    
    font-family: "Open Sans", Helvetica, Arial, "Lucida Grande", sans-serif;
    font-size: 16px;
    line-height: 16px;
    font-weight: 600;
    color: ${({ theme, disabled }) => disabled ? theme.disabledFontColor : theme.primaryColor};
    
    box-sizing: border-box;
    padding: 8px 8px;
    
    border: 1px solid ${({ theme, errors }) => errors ? theme.errorColor : theme.disabledBackgroundColor};
    outline: none;
    border-radius: 5px;
    background-color: ${({ theme, disabled }) => disabled ? theme.disabledBackgroundColor : theme.cardColor};
    
    &:focus {
      border-color: ${({ theme, errors }) => errors ? theme.errorColor : theme.primaryColor};
    }
    
    &::placeholder {
        color: ${({ theme }) => theme.disabledFontColor};
        font-weight: 400;
        line-height: initial;
    }
    &::-ms-input-placeholder {
      color: ${({ theme }) => theme.disabledFontColor};
    }    
  }
  textarea.textarea-field {
    line-height: 22px;
  }
`;

InputContainer.defaultProps = {
  maxWidth: '100%',
};

export default InputContainer;
